export const PaymentStates = {
    Initialized: 'Initialized',
    Approved: 'Approved',
    Cancelled: 'Cancelled',
    Rejected: 'Rejected',
    Error: 'Error',
    Refunded: 'Refunded',
    Voided: 'Voided',
    PartiallyRefunded: 'PartiallyRefunded',
    Changed: "Changed",
    Processing: "Processing"
}

export const PaymentLabels = {
    Initialized: 'Inicializado',
    Approved: 'Aprobado',
    Cancelled: 'Cancelado',
    Rejected: 'Rechazado',
    Error: 'Error',
    Refunded: 'Devuelto',
    Voided: 'Anulado',
    PartiallyRefunded: 'Parcialmente Devuelto',
    Changed : "Cambiado",
    Processing: "Procesando"
}